import { Children, forwardRef, Fragment, HtmlHTMLAttributes, memo } from "react";
import classNames from "classnames";
import { ArrowRight } from "./icon";

import styles from "./style.module.scss"

export type CommandShortcutProps = {
  supportingText?: string
  shortcutClassName?: string
  supportingTextClassName?: string
} & HtmlHTMLAttributes<HTMLSpanElement>

export const CommandShortcut = memo(forwardRef<HTMLSpanElement, CommandShortcutProps>((
  {
    children,
    className,
    supportingText = "",
    shortcutClassName,
    supportingTextClassName,
    ...props
  }, ref) => {
  const count = Children.count(children)

  return (
    <span
      className={classNames(className, styles.root)}
      {...props}
      ref={ref}
    >
      {Children.map(children, (child, index) => (
        <Fragment key={index}>
          <span className={classNames(shortcutClassName, styles.shortcut)}>{child}</span>
          {index < count - 1 && (
            <>
              {supportingText && <span className={classNames(supportingTextClassName, styles.supportingText)}>{supportingText}</span>}
              <ArrowRight />
            </>
          )}
        </Fragment>
      ))}
    </span>
  );
}));